/**
 * @file 配置控制
 * @author mengchen <mengchen@babytree-inc.com>
 */
// 从 URL 参数获取环境
// function getEnvFromUrl() {
//   if (typeof window === 'undefined') return null;
  
//   const urlParams = new URLSearchParams(window.location.search);
//   return urlParams.get('env');
// }
// const urlEnv = getEnvFromUrl();

// const getHostEnv = function() {
//   const {host} = location;
//   if (urlEnv === 'prod' || host == 'h5.babytree.com') {
//     return 'online';
//   }
//   // pre
//   if (urlEnv === 'pre' || host.indexOf('pre.fpm') > -1) {
//     return 'pre';
//   }
//   // test
//   if (urlEnv === 'test' || host.indexOf('-test') > -1) {
//     return 'test';
//   }
//   return 'local';
// };
const getHostEnv = function() {
  const {host} = location;
  if (host == 'h5.babytree.com') {
    return 'online';
  }
  // pre
  if (host.indexOf('pre.fpm') > -1) {
    return 'pre';
  }
  // test
  if (host.indexOf('-test') > -1) {
    return 'test';
  }
  return 'local';
};

/**
 * 与 go 跨域预检失败时（如 origin 为 h5.babytree-dev.com 未在 go CORS、OPTIONS 非 2xx）：走同源 /go_tool，由 Nginx 反代到 go。
 * h5-1 / CDN 等正式测试域若已配好 CORS，勿把其 hostname 加进来。
 */
const GO_TOOL_SAME_ORIGIN_TEST_HOSTS = [
  'h5.babytree-dev.com',
];

/** 当前访问域名是否应对 go_tool 使用同源路径（//当前host/go_tool/...） */
export function isGoToolSameOriginAsPage() {
  if (typeof location === 'undefined') return false;
  return GO_TOOL_SAME_ORIGIN_TEST_HOSTS.indexOf(location.hostname) !== -1;
}

export const processEnv = {
  nodeEnv: process.env.NODE_ENV,
  // buildTimestamp: new Date(process.env.BUIDTIMESTAMP),
  // version: process.env.VERSION,
  // publicPath: process.env.PUBLICPATH,
  // rootPath: process.env.ROOTPATH,
  hostEnv: getHostEnv()
};

export const getStorePrefix = function() {
  return '@@babytree-tool-';
};

export function getGOHost(serviceNum = '1') {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//go.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//go.pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return `//go.${serviceNum}.babytree-test.com/`;
  }
  // local
  return `//go.${serviceNum}.babytree-test.com/`;
}

export function getPHPHost(serviceNum = '21') {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//api.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//api.pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return `//${serviceNum}.babytree-test.com/`;
  }
  // local
  return `//${serviceNum}.babytree-test.com/`;
}

export function getNewMapHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//newmapi.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//newmapi.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//newmapi.babytree-test.com/';
  }
  // local
  return '//newmapi.babytree-test.com/';
}

export function getMapiWebHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//mapiweb.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//mapiweb.pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//mapiweb.babytree-test.com/';
  }
  // local
  return '//mapiweb.babytree-test.com/';
}

export function getABTestingHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//abtesting.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//abtesting.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//abtesting.babytree.com/';
  }
  // local
  return '//abtesting.babytree.com/';
}

export function getOpenHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//open.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//open-21.babytree-test.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//open.21.babytree-test.com/';
  }
  // local
  return '//open.21.babytree-test.com/';
}

export function getMeitunHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//m.meitun.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//m.meitun-test.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//m.meitun-test.com/';
  }
  // local
  return '//m.meitun-test.com/';
}

export function getWebviewHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//webview.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv === 'pre') {
    return '//pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//webview.21.babytree-test.com/';
  }
  // local
  return '//webview.21.babytree-test.com/';
}

export function getShopWebviewHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//h5-fe-shop.meitun.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//h5-fe-shop.meitun-test.com/';
  }
  // local
  return '//h5-fe-shop.meitun-test.com/';
}

export function getShopMeitunHost() {
  // online
  if (processEnv.hostEnv === 'online') {
    return '//shop.meitun.com/';
  }
  // test
  if (processEnv.hostEnv === 'test') {
    return '//shop.meitun-test.com/';
  }
  // local
  return '//shop.meitun-test.com/';
}

/**
 *
 * https://h5-1.babytree-test.com/h5_fe_tool/html/cando/index?
 * &client-baby-status=3
 * &enc-user-id=u194066745079
 * &idfa=BB7D9758-A393-488A-A6BA-B5C61C87AD68&babytree-app-id=pregnancy
 * &babytree-client-type=ios
 * &babytree-app-version=8.26.0
 * &babytree-app-mac=206f56d31cb57206776dda09f74a4df0fc59276b
 * &babytree-app-longitude=116.462216
 * &babytree-app-latitude=39.928028
 * &bpreg_brithday=2016-05-24
 * &bpreg-brithday=2016-05-24
 * &client-role=1¤t-baby-id=95312565
 * &babytree-app-imei=863454034143540
 */

export const QUERY_KEY_WHITE_MAP = {
  'babytree-app-id': 1,
  'babytree-app-latitude': 1,
  'babytree-app-longitude': 1,
  'babytree-app-mac': 1,
  'babytree-app-version': 1,
  'babytree-client-type': 1,
  'bpreg-brithday': 1,
  bpreg_brithday: 1,
  'client-baby-status': 1,
  'client-role': 1,
  'enc-user-id': 1,
  'babytree-app-device-model': 1,
  'current-baby-id': 1,
  prepare_status: 1,
  'android-id': 1,
  'babytree-app-imei': 1,
  tool_id: 1,
  idfa: 1,
  moblie_share_src: 1,
  share_pregst: 1,
  share_dest: 1,
  share_ts: 1,
  share_uid: 1,
  share_bd: 1,
  navigation_bar_hidden: 1,
  debug: 1
};

export const NEWVIEW_QUERY_KEY_WHITE_MAP = {
  navigation_bar_hidden: 1,
  forbid_scroll: 1,
  from_tool_id: 1,
  off_line: 'h5_fe_tool'
};

export const NEW_WEBVIEW_QUERY = 'babytree-fe-webview';

window.__processEnv = processEnv;
